import {AppAction} from '../../appActions';
import {ConversationsActionsEnum} from '../../data/conversations/conversationsActions';
import {MessageActionsEnum} from '../../data/messages/messagesActions';
import {MessageViewerPanelState} from './messageViewerPanelState';

/*
 * Viewer.
 */

export function messageViewerPanelReducer(state: MessageViewerPanelState, action: AppAction) {
  switch (action.type) {
    case ConversationsActionsEnum.CONVERSATION_ACCESS_DENIED:
    case ConversationsActionsEnum.CONVERSATION_DELETED: {
      if (action.payload.conversationId === state.conversationId) {
        return undefined;
      }

      return state;
    }
    case MessageActionsEnum.MESSAGE_DELETED: {
      if (action.payload.messageUid === state.messageUid) {
        return undefined;
      }

      return state;
    }
    default:
      return state;
  }
}
